import { action } from 'easy-peasy';
import { IActionRestoreLocalAdmin } from '../types';

const restoreLocalAdmin: IActionRestoreLocalAdmin = action((state, localAdminId) => {
  const updatedList = state.list.map(item =>
    item.id !== localAdminId ? item : { ...item, status: 'Active' },
  );

  state.list = updatedList;
});

export default restoreLocalAdmin;
